// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { walletDataSuccess,walletDataError } from './action';
import { GET_WALLET_BALANCE } from '../actionTypes';
import { getWalletBalance } from '../../api';

function* getWalletSaga(action) {
  try {
    const { getBalancePayload } = action.payload;
    const data = yield getWalletBalance(getBalancePayload)
    // const data = yield   getDealershipByIdWithWalletInfo(getFromLocalStorage("user")?.dealerInfo.dealership_id)

      if (data?.data) {
        yield put(walletDataSuccess(data.data?.result?.balance));
      }
  } catch (error) {
    yield put(walletDataError(error));
  }
}


export function* watchWalletData() {
  yield takeLatest(GET_WALLET_BALANCE, getWalletSaga);
}

